/**
 * FHB free-shipping signup popup -- native replacement for the Tydal/
 * Booster "ba_widget" popup. Same job (email capture -> free shipping code)
 * but built on the site's own brand system (fhb-modal) instead of a
 * third-party app's styling, so it can't drift from the rest of the site
 * and doesn't depend on that app staying installed.
 *
 * Email capture posts straight to Shopify's native customer/newsletter
 * endpoint (the same one Dawn's own newsletter section uses), so signups
 * land in the store's real Customer list and flow into whatever email tool
 * is connected there. The code shown after signup is a real Shopify
 * discount (FREESHIP, one use per customer) -- nothing here fabricates it.
 */
(function () {
  'use strict';

  if (window.__fhbShippingPopupStarted) return;
  window.__fhbShippingPopupStarted = true;

  var STORAGE_KEY = 'fhb_shipping_popup_seen';
  var SHOW_DELAY_MS = 1800;
  var DISCOUNT_CODE = 'FREESHIP';

  var COPY = {
    headline: 'Get Free Shipping Today!',
    desc: "Enter your email and we'll send your free shipping code instantly.",
    placeholder: 'Email Address',
    yes: 'Claim Discount',
    no: 'No thanks',
    finePrint: 'You are signing up to receive communication via email and can unsubscribe at any time.',
    errorInvalid: 'Enter a valid email address.',
    errorGeneric: "Something went wrong -- please try again.",
    successHeadline: "You're in!",
    successDesc: 'Use this code at checkout for free shipping:',
    copy: 'Copy code',
    copied: 'Copied!',
    continueShopping: 'Continue shopping'
  };

  function hasSeenPopup() {
    try {
      return localStorage.getItem(STORAGE_KEY) === '1';
    } catch (error) {
      return false;
    }
  }

  function markSeen() {
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch (error) {
      // Storage unavailable (private browsing, etc.) -- just skip persisting.
    }
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function submitEmail(email) {
    var body = new URLSearchParams();
    body.set('form_type', 'customer');
    body.set('utf8', '✓');
    body.set('contact[email]', email);
    body.set('contact[tags]', 'newsletter');
    return fetch('/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString()
    });
  }

  var overlay, headlineEl, descEl, formEl, inputEl, errorEl,
    yesBtn, noBtn, finePrintEl, successPanel, codeTextEl, copyBtn, continueBtn;

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'fhb-modal-overlay';
    overlay.innerHTML =
      '<div class="fhb-modal fhb-shipping-modal">' +
        '<h3 class="fhb-modal-headline"></h3>' +
        '<p class="fhb-modal-desc"></p>' +
        '<form class="fhb-shipping-form" novalidate>' +
          '<input type="email" class="fhb-shipping-input" autocomplete="email" required>' +
          '<div class="fhb-shipping-error" hidden></div>' +
          '<div class="fhb-modal-actions">' +
            '<button type="submit" class="fhb-modal-yes"></button>' +
            '<button type="button" class="fhb-modal-no"></button>' +
          '</div>' +
        '</form>' +
        '<div class="fhb-shipping-success" hidden>' +
          '<h3 class="fhb-modal-headline"></h3>' +
          '<p class="fhb-modal-desc"></p>' +
          '<div class="fhb-shipping-code">' +
            '<span class="fhb-shipping-code-text"></span>' +
            '<button type="button" class="fhb-shipping-copy-btn"></button>' +
          '</div>' +
          '<div class="fhb-modal-actions">' +
            '<button type="button" class="fhb-modal-yes fhb-shipping-continue-btn"></button>' +
          '</div>' +
        '</div>' +
        '<p class="fhb-shipping-fine-print"></p>' +
      '</div>';
    document.body.appendChild(overlay);

    var card = overlay.querySelector('.fhb-modal');
    // The card's first headline/desc belong to the form panel; the success
    // panel's own copies are queried separately below.
    headlineEl = card.querySelector('.fhb-modal-headline');
    descEl = card.querySelector('.fhb-modal-desc');
    formEl = overlay.querySelector('.fhb-shipping-form');
    inputEl = overlay.querySelector('.fhb-shipping-input');
    errorEl = overlay.querySelector('.fhb-shipping-error');
    yesBtn = overlay.querySelector('.fhb-shipping-form .fhb-modal-yes');
    noBtn = overlay.querySelector('.fhb-shipping-form .fhb-modal-no');
    finePrintEl = overlay.querySelector('.fhb-shipping-fine-print');
    successPanel = overlay.querySelector('.fhb-shipping-success');
    codeTextEl = overlay.querySelector('.fhb-shipping-code-text');
    copyBtn = overlay.querySelector('.fhb-shipping-copy-btn');
    continueBtn = overlay.querySelector('.fhb-shipping-continue-btn');

    headlineEl.textContent = COPY.headline;
    descEl.textContent = COPY.desc;
    inputEl.placeholder = COPY.placeholder;
    yesBtn.textContent = COPY.yes;
    noBtn.textContent = COPY.no;
    finePrintEl.textContent = COPY.finePrint;

    var successHeadlineEl = successPanel.querySelector('.fhb-modal-headline');
    var successDescEl = successPanel.querySelector('.fhb-modal-desc');
    successHeadlineEl.textContent = COPY.successHeadline;
    successDescEl.textContent = COPY.successDesc;
    codeTextEl.textContent = DISCOUNT_CODE;
    copyBtn.textContent = COPY.copy;
    continueBtn.textContent = COPY.continueShopping;

    formEl.addEventListener('submit', function (event) {
      event.preventDefault();
      var email = inputEl.value.trim();
      if (!isValidEmail(email)) {
        showError(COPY.errorInvalid);
        return;
      }
      hideError();
      yesBtn.disabled = true;
      noBtn.disabled = true;
      yesBtn.textContent = '...';
      submitEmail(email)
        .then(function () {
          markSeen();
          showSuccess();
        })
        .catch(function () {
          yesBtn.disabled = false;
          noBtn.disabled = false;
          yesBtn.textContent = COPY.yes;
          showError(COPY.errorGeneric);
        });
    });

    noBtn.addEventListener('click', function () {
      markSeen();
      close();
    });

    copyBtn.addEventListener('click', function () {
      var done = function () {
        copyBtn.textContent = COPY.copied;
        setTimeout(function () {
          copyBtn.textContent = COPY.copy;
        }, 1500);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(DISCOUNT_CODE).then(done).catch(done);
      } else {
        done();
      }
    });

    continueBtn.addEventListener('click', close);
  }

  function showError(message) {
    errorEl.textContent = message;
    errorEl.hidden = false;
  }

  function hideError() {
    errorEl.hidden = true;
    errorEl.textContent = '';
  }

  function showSuccess() {
    formEl.hidden = true;
    finePrintEl.hidden = true;
    successPanel.hidden = false;
  }

  function close() {
    overlay.classList.remove('is-active');
  }

  function show() {
    if (!overlay) build();
    overlay.classList.add('is-active');
  }

  function start() {
    if (hasSeenPopup()) return;
    setTimeout(show, SHOW_DELAY_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
